import { styled as muiStyled } from '@mui/material'
import { TimeField } from '@mui/x-date-pickers'

export const TimerTimeClockInput = muiStyled('input')(
  ({ theme }) => `
    width: 100%;
    border: none;
    background: transparent;
    outline: none;
    text-align: center;
    
`,
)

export const MuiTimerTimeClockInput = muiStyled(TimeField)(
  ({ theme, isTimeInvalid }) => `
  .MuiFormLabel-root {
    display: none;
  }
  .MuiOutlinedInput-notchedOutline{
    display:none;
  }
  .MuiInputBase-input {
    color: ${isTimeInvalid ? '#ff6666' : '#fff'};
    font-size: 68px;
    width: 100%;
    text-align:center;
    font-family: "Roboto Mono", monospace;
    @media (min-width: 768px) {
      font-size: 80px;
    }
  }
`,
)
